import { render, staticRenderFns } from "./UcrsTabs.vue?vue&type=template&id=2dacf54d"
import script from "./UcrsTabs.vue?vue&type=script&lang=js"
export * from "./UcrsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports